'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _commondrgchanges = require('./commondrgchanges.component');

var _commondrgchanges2 = _interopRequireDefault(_commondrgchanges);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var commondrgchangesModule = _angular2.default.module('commondrgchanges', [_angularUiRouter2.default]).component('commondrgchanges', _commondrgchanges2.default);

exports.default = commondrgchangesModule;


// WEBPACK FOOTER //
// ./client/app/common/reports/commondrgchanges/commondrgchanges.js